<template>
    <div class="page-tabs-box">
        <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane label="群组列表" name="1" link="/operation/chatGroup/list"></el-tab-pane>
            <el-tab-pane v-if="$utils.have('/chatGroup/template/detail')" label="自动建群规则" name="2" link="/operation/chatGroup/template"></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    props:{
        name:{
            type: String,
            default: '1'
        }
    },
    data(){
        return{
            activeName: this.name
        }
    },
    methods:{
        clickEvent(tab){
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link)
        }
    }
}
</script>